const state = () => {
  return {
    sc_employee_roles: [],
    sc_employee_role: {},
    sc_employee_role_filters: {},
  }
}

export default state;
